import { useMutation } from 'react-query'
import { ApiService } from 'src/services/api.service'

export const SYNC_EVENTS_CACHE_KEY = 'sync-events'

export const useSyncEvents = () => {
  return useMutation(SYNC_EVENTS_CACHE_KEY, () => ApiService.Events.syncEvents())
}
